import { styled } from "@mui/material/styles";

// Components
import { MaterialDesignContent } from "notistack";
import { ReactComponent as CloseIcon } from "~/assets/icons/xmark-solid.svg";

// Themes
import theme from "~/components/Common/Theme";

const styledName = "NotiStackWrapper";

const successColor = "#4BB543";
const errorColor = theme.palette.error.main;

export const StyledMaterialDesignContent = styled(MaterialDesignContent, {
  name: styledName,
})({
  "&.notistack-MuiContent": {
    border: "solid 1px",
    borderRadius: "10px",
    fontSize: "1.6rem",
    width: "350px",
    backgroundColor: "white",
    display: "flex",
    alignItems: "start",
    flexWrap: "nowrap",
  },
  "&.notistack-MuiContent-default": {
    color: errorColor,
    borderColor: errorColor,
  },
  "&.notistack-MuiContent-success": {
    color: successColor,
    borderColor: successColor,
  },
  "&.notistack-MuiContent-error": {
    color: errorColor,
    borderColor: errorColor,
  },
  "&.notistack-MuiContent-info": {
    color: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
  },
});

export const StyledCloseButton = styled(CloseIcon, { name: styledName })({
  "&": {
    transition: "all 0.2s ease-in",
    cursor: "pointer",
    margin: "5px",
    ":hover": {
      transform: "scale(1.4)",
    },
  },
});
